exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host >>> .custom-avatar {\n  width: 3em !important;\n  padding-right: 0 !important;\n}\n\n:host >>> .custom-avatar a {\n  display: flex;\n  align-items: center;\n  height: 3em !important;\n  overflow: hidden;\n}\n\n:host >>> .custom-avatar a img {\n  width: 3em !important;\n  height: auto !important;\n  border-radius: 0 !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./app/components/users-list/users-list.component.css
// module id = 871
// module chunks = 0